var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComponentShowcase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#011329"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#02203d"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 80,
    height: 60,
    rx: 4,
    fill: "#f0f0f0",
    stroke: "#ddd"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 20,
    width: 80,
    height: 60,
    rx: 4,
    fill: "#1a1a1a",
    stroke: "#333"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 20,
    width: 80,
    height: 60,
    fill: "#000",
    stroke: "#fff",
    strokeWidth: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 20,
    width: 90,
    height: 60,
    rx: 4,
    fill: "#0a0a0a",
    stroke: "#00ffff",
    strokeWidth: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 100,
    width: 80,
    height: 60,
    rx: 12,
    fill: "#2d3a2d",
    stroke: "#7a9a7a"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 100,
    width: 80,
    height: 60,
    rx: 16,
    fill: "#2d1a4a",
    stroke: "#c4a0ff",
    strokeDasharray: "4,2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 100,
    width: 80,
    height: 60,
    rx: 4,
    fill: "#1a0a1f",
    stroke: "#d4af37"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 100,
    width: 90,
    height: 60,
    rx: 8,
    fill: "#011329",
    stroke: "#ffaf00"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 180,
    width: 115,
    height: 50,
    rx: 6,
    fill: "#011329",
    stroke: "#3c7f72"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 180,
    width: 115,
    height: 50,
    rx: 6,
    fill: "#011329",
    stroke: "#ff00ff",
    strokeOpacity: 0.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 180,
    width: 110,
    height: 50,
    rx: 6,
    fill: "#011329",
    stroke: "#ffaf00",
    strokeOpacity: 0.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 250,
    width: 360,
    height: 30,
    rx: 4,
    fill: "rgba(0,0,0,0.3)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 270,
    fontFamily: "monospace",
    fontSize: 12,
    fill: "#f5efe6",
    textAnchor: "middle"
  }, "7 THEMES  -  17 COMPONENTS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponentShowcase);
export default __webpack_public_path__ + "static/media/componentShowcase.4e6c05ed87d898d8b4b17cbbfcc76e39.svg";
export { ForwardRef as ReactComponent };